<template>
  <div>
    <Header :title="''" />
    <div class="boss-admin-container clearfix">
      <sidebar />
      <div class="boss-main-container pega-error-container">
        <div class="boss-main-wrap">
          <div class="grid-container margin-auto text-center">
            <div class="font-size-1-5em">
              <div>500</div>
              <img
                src="@/assets/images/littlemy_500_C.png"
                class="pega-mb-1-5"
              >
              <div>ページが表示できません</div>
            </div>
            <div class="font-size-1em margin-top-1">
              <div>ご不便をお掛けし、申し訳ございません。</div>
              <div>少し時間を置いて、もう一度お試しいただけますでしょうか。</div>
            </div>
            <div class="boss-more-button margin-top-2">
              <button
                data-test="dashboard-button"
                class="float-center boss-button-center boss-button-large"
                @click="$router.push({ name: 'dashboardTop' })"
              >
                ダッシュボードに戻る
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import Sidebar from '@/components/organisms/Sidebar'

export default {
  components: {
    Sidebar,
    Header
  }
}
</script>
